import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import TreeMapChart from "../../../../../components/chart/TreeMapChart";
import ReactTable from "../../../../../lib/table/react-table";
import TableHeaderSwiper from "../components/TableHeaderSwiper";
import SparlLineBar from "../../../../../components/chart/SparlLineBar";
import {
  useGetLocationMajorCities,
  useGetLocationZonalDistribution,
  useGetSummaryCampaignGroupList,
  useGetLocationReport,
  useGetLocationReportCtr,
  useGetLocationStateMap,
} from "../../../../../queries/query-hooks/workspace/brand-ads-hook";
import MapAnalyticsSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/map-analytics-skeleton";
import SquareChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/square-chart-skeleton";
import CommonTableLoader from "../../../../../skeleton/common-table-loader";
import NavSwiperSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/nav-swiper-skeleton";
import PageNotFound from "../../../../PageNotFound";
import { fallbackImages } from "../../../../../utilities/fallback-images";
import { useParams } from "react-router-dom";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import Skeleton from "../../../../../components/skeleton";
import useCsvDownloader from "../../../../../components/custom-hooks/use-csv-downloader";
import { formatLocalizedDate } from "../../../../../common/utils/utils";
import * as dayjs from "dayjs";
import { ProjectHeaderTopBar, TableHeader } from "@ui";
import ProjectFilters from "../components/ProjectFilters";
import IndiaMap from "components/chart/IndiaMap";
import { selectProject } from "store/project/project.selector";
import { useDispatch, useSelector } from "react-redux";
import { updateProject } from "store/project/project.action";
const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function Location() {
  const { project_id } = useParams();
  const dispatch = useDispatch();
  const project = useSelector(selectProject);
  const { downloadCSV } = useCsvDownloader();

  const handleTableCsvDownload = () => {
    downloadCSV(tableCsvFormat);
  };

  const [loactionCtrApiEnable, setLoactionCtrApiEnable] = useState(false);

  const [activeCampaignGroup, setActiveCampaignGroup] = useState({});
  function getGroupIdsCommaSeparated(data) {
    return data.map((item) => item.group_id).join(",");
  }

  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);

  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [isProjectChange, setIsProjectChange] = useState(false);

  useEffect(() => {
    setIsProjectChange(true);
  }, [project_id]);

  const { data: stateMapData, isLoading: isStateMapLoading } =
    useGetLocationStateMap(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
        type: "percentage",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: majorCities, isLoading: isMajorCitiesLoading } =
    useGetLocationMajorCities(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );
  const { data: zonalDistibution, isLoading: isZonalDistributionLoding } =
    useGetLocationZonalDistribution(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: locationReport, isLoading: isLocationReportLoading } =
    useGetLocationReport(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      activeCampaignGroup?.id &&
        !!dateRangePayload.start_date &&
        !!dateRangePayload.end_date
        ? true
        : false
    );

  const { data: locationReportCtr, isLoading: isLocationReportCtrLoading } =
    useGetLocationReportCtr(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      loactionCtrApiEnable &&
        activeCampaignGroup?.id &&
        !!dateRangePayload.start_date &&
        !!dateRangePayload.end_date
        ? true
        : false
    );

  const { data: campaignGroupList, isLoading: isCampaignGroupListLoading } =
    useGetSummaryCampaignGroupList(project_id, {
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    });

  useEffect(() => {
    if (locationReport?.length > 0) {
      setLoactionCtrApiEnable(true);
    } else {
      setLoactionCtrApiEnable(false);
    }
  }, [locationReport]);

  function mergedLocationData(locationData, locationMatrix) {
    if (!locationMatrix && locationData) {
      return locationData.map((location) => ({
        ...location,
        unique_views: "loading",
        unique_clicks: "loading",
        ctr: "loading",
      }));
    }
    if (locationData && locationData?.length > 0) {
      const mergedData = locationData.map((location) => {
        const matchingMatrix = locationMatrix.find(
          (matrix) => matrix.name === location.name
        );
        return {
          ...location,
          ...(matchingMatrix || {}),
        };
      });
      return mergedData && Array.isArray(mergedData)
        ? mergedData.sort((a, b) => b.views - a.views)
        : [];
    }
  }

  const locationTableData = mergedLocationData(
    locationReport,
    locationReportCtr
  );

  const TableColumnData = [
    {
      Header: "States",
      columnId: 1,
      accessor: "name",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : "-"),
    },
    {
      Header: "Viewed",
      columnId: 2,
      accessor: "views",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    {
      Header: "Avg. Frequency",
      columnId: 3,
      accessor: "average_fre",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    // {
    //   Header: "Mobile impr",
    //   columnId: 4,
    //   accessor: "mobile_imp",
    //   disableFilters: true,
    //   Cell: ({ value }) => (value ? value : 0),
    // },
    // {
    //   Header: "Web impr (%)",
    //   columnId: 5,
    //   accessor: "web_imp",
    //   disableFilters: true,
    //   Cell: ({ value }) => (value ? value : 0),
    // },
    // {
    //   Header: "Total impr",
    //   columnId: 6,
    //   accessor: "total_impr",
    //   disableFilters: true,
    //   Cell: ({ value }) => (value ? value : 0),
    // },
    {
      Header: "Total CTR",
      columnId: 9,
      accessor: "ctr",
      disableFilters: true,
      Cell: ({ value, row }) => {
        return value == "loading" ? (
          <Skeleton width={100} />
        ) : value ? (
          `${value} %`
        ) : (
          0
        );
      },
    },
    // {
    //   Header: "Trends",
    //   columnId: 10,
    //   accessor: "date_Data",
    //   disableFilters: true,
    //   // Cell: ({ value, row }) => <SparlLineBar id={row.original.banner_id} series={[348155, 348155, 348155, 339279, 339197, 339006, 323634]} labels={DAYS_OF_WEEK} />
    //   Cell: ({ value }) =>
    //     value && value?.length > 0 ? (
    //       <SparlLineBar series={value.split(",")} labels={DAYS_OF_WEEK} />
    //     ) : (
    //       "-"
    //     ),
    // },
  ];

  function formatZonalDistibutionData(inputArray) {
    if (!Array.isArray(inputArray)) return [];
    return inputArray.map(({ name, user_count }) => ({
      x: name,
      y: user_count,
    }));
  }

  const transformMapData = (inputArray) => {
    const result = inputArray.reduce((acc, { User_count, name }) => {
      acc[name] = User_count;
      return acc;
    }, {});
    return [result];
  };

  const dimentionChartData =
    zonalDistibution && zonalDistibution?.length > 0
      ? formatZonalDistibutionData(zonalDistibution)
      : [];

  const transformStateMapData = (data = [], key) => {
    return [
      data?.reduce((acc, item) => {
        if (item.name && item[key] !== null) {
          acc[item.name] = item[key];
        }
        return acc;
      }, {}),
    ];
  };
  const stateMapViewsData = transformStateMapData(
    stateMapData,
    "views_percent"
  );

  const tableCsvFormat = {
    header: [
      "States",
      "Viewed",
      "Avg. Frequency",
      "Total CTR",
      // "Mobile Impr",
      // "Web Impr",
      // "Total impr",
    ],
    column: [
      "name",
      "views",
      "average_fre",
      "ctr",
      // "mobile_imp",
      // "web_imp",
      // "total_impr",
    ],
    // chart: {
    //   header: "Trends",
    //   column: "date_Data",
    // },
    rows: locationTableData,
  };

  // console.log("locationTableData", locationTableData);

  useEffect(() => {
    if (projectDetails && projectDetails?.length > 0) {
      const today = dayjs();
      const projectEndDate = dayjs(projectDetails[0]?.project_end_date);
      let result = projectDetails[0]?.project_end_date;

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        result = today.subtract(1, "day");
      } else {
        result = projectEndDate;
      }

      if (project?.start_date && project?.end_date && !isProjectChange) {
        setDateRangePayload({
          start_date: project?.start_date,
          end_date: project?.end_date,
        });
        dispatch(
          updateProject({
            start_date: project?.start_date,
            end_date: project?.end_date,
          })
        );
      } else {
        setDateRangePayload({
          start_date: formatLocalizedDate(
            new Date(projectDetails[0]?.project_start_date),
            "YYYY-MM-DD[T]00:00:00.000Z"
          ),
          end_date: formatLocalizedDate(
            new Date(result),
            "YYYY-MM-DD[T]23:59:59.000Z"
          ),
        });
        dispatch(
          updateProject({
            start_date: formatLocalizedDate(
              new Date(projectDetails[0]?.project_start_date),
              "YYYY-MM-DD[T]00:00:00.000Z"
            ),
            end_date: formatLocalizedDate(
              new Date(result),
              "YYYY-MM-DD[T]23:59:59.000Z"
            ),
          })
        );
        setIsProjectChange(false);
      }
    }
  }, [projectDetails, project_id]);

  const allDataLoaded =
    !isStateMapLoading && !isMajorCitiesLoading && !isZonalDistributionLoding;

  const hasIndiaMap = stateMapData?.length > 0;
  const hasMajorCities = majorCities?.length > 0;
  const hasZonalDistribution = zonalDistibution?.length > 0;

  if (!allDataLoaded) {
    return (
      <div className="row row-cols-sm-2">
        <div className="mb-4">
          <MapAnalyticsSkeleton />
        </div>
        <div className="mb-4">
          <div className="row row-col-sm-2">
            <div className="mb-2">
              <SquareChartSkeleton />
            </div>
            <div className="mb-4">
              <SquareChartSkeleton />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="row">
      <div className="col-sm-12">
        <ProjectHeaderTopBar
          projectType="Brand Ads"
          title="Location Insights"
          projectStartDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_start_date
              : ""
          }
          projectEndDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_end_date
              : ""
          }
          isProjectDetailsLoading={isProjectDetailsLoading}
          rightComponent={
            <ProjectFilters
              title="Location Insights"
              dateLabel={dateRangePayload}
              setDateRangePayload={setDateRangePayload}
              projectStartDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_start_date
                  : ""
              }
              projectEndDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_end_date
                  : ""
              }
              isProjectDetailsLoading={isProjectDetailsLoading}
            />
          }
        />
      </div>
      <div className="col-sm-12">
        <div className="row">
          {hasIndiaMap && (
            <div
              className={`d-flex flex-column mb-4 ${
                hasMajorCities || hasZonalDistribution
                  ? "col-lg-6 col-sm-12 pe-2"
                  : "col-12"
              }`}
            >
              <IndiaMap
                title="Location"
                stateData={stateMapViewsData}
                valueSuffix="%"
              />
            </div>
          )}

          {(hasMajorCities || hasZonalDistribution) && (
            <div
              className={`col-sm-12 mb-4 ${
                hasIndiaMap ? "col-lg-6" : "col-12"
              }`}
            >
              <div className="row">
                {hasMajorCities && (
                  <div className="mb-2 col-sm-12">
                    <Card>
                      <Card.Header>
                        <h5 className="text-center subHeading position-relative">
                          Major Cities
                        </h5>
                      </Card.Header>
                      <Card.Body className="d-flex flex-wrap justify-content-center gap-2 text-black-50">
                        {majorCities.map((item, index) => (
                          <span
                            key={`city-${index}`}
                            className="border rounded-pill px-3 py-2"
                          >
                            {item.name}
                          </span>
                        ))}
                      </Card.Body>
                    </Card>
                  </div>
                )}

                {hasZonalDistribution && (
                  <div className="col-sm-12">
                    <TreeMapChart
                      title="Zonal Distribution"
                      series={dimentionChartData}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="col-sm-12">
        <Card>
          <TableHeader
            title="Locations"
            downloadProps={{
              needCsvDownload:
                !isLocationReportLoading && locationReport?.length > 0,
              exportCSVHandler: handleTableCsvDownload,
            }}
          />

          {!isCampaignGroupListLoading && campaignGroupList.length > 0 ? (
            <div className="px-md-4 px-3">
              <TableHeaderSwiper
                className={"me-0 mt-4"}
                title={campaignGroupList}
                activeCampaignGroup={activeCampaignGroup}
                setActiveCampaignGroup={setActiveCampaignGroup}
              />
            </div>
          ) : (
            <div className="col-sm-12">
              <NavSwiperSkeleton />
            </div>
          )}

          <Card.Body>
            {!isLocationReportLoading && locationReport?.length > 0 ? (
              <ReactTable
                key={"location-report"}
                data={locationTableData}
                columns={TableColumnData}
                isPaginationShow={false}
                bordered
                noDataText="no data"
                noDataImage={fallbackImages.noActionData}
              />
            ) : isLocationReportLoading ? (
              <CommonTableLoader tableRowLength={5} />
            ) : null}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default Location;
